/**
 * para: 商品ページの「現在 N 人がこの商品を見ています」(snippets/product-viewer-count.liquid)
 * ※ 人数は乱数(実測ではない)。2026-09-30 オーナー判断で採用。リスクは docs/notes/cart_features_20260930.md
 *  - 初期値: 同じタブで同じ商品を見ていたら直前の値、無ければ min〜max のランダム
 *  - interval-min〜max 秒ごとに ±1〜2 だけ動かす(min〜max の範囲に収める)
 */
if (!customElements.get('product-viewer-count')) {
  customElements.define(
    'product-viewer-count',
    class ProductViewerCount extends HTMLElement {
      connectedCallback() {
        this.min = parseInt(this.dataset.min, 10) || 3;
        this.max = Math.max(this.min, parseInt(this.dataset.max, 10) || 12);
        this.intervalMin = (parseInt(this.dataset.intervalMin, 10) || 30) * 1000;
        this.intervalMax = Math.max(this.intervalMin, (parseInt(this.dataset.intervalMax, 10) || 60) * 1000);
        this.storageKey = `para.viewers.${this.dataset.productId}`;
        this.countEl = this.querySelector('.product-viewers__count');
        if (!this.countEl) return;

        let value = this.restore();
        if (value === null) value = this.randomInt(this.min, this.max);
        this.set(value);
        this.hidden = false;
        this.scheduleNext();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      randomInt(a, b) {
        return Math.floor(Math.random() * (b - a + 1)) + a;
      }

      clamp(v) {
        return Math.min(this.max, Math.max(this.min, v));
      }

      restore() {
        try {
          const saved = parseInt(window.sessionStorage.getItem(this.storageKey), 10);
          return Number.isFinite(saved) ? this.clamp(saved) : null;
        } catch (e) {
          return null;
        }
      }

      set(value) {
        this.value = this.clamp(value);
        this.countEl.textContent = String(this.value);
        try {
          window.sessionStorage.setItem(this.storageKey, String(this.value));
        } catch (e) {}
      }

      scheduleNext() {
        const wait = this.randomInt(this.intervalMin, this.intervalMax);
        this.timer = setTimeout(() => {
          const step = this.randomInt(1, 2) * (Math.random() < 0.5 ? -1 : 1);
          let next = this.clamp(this.value + step);
          if (next === this.value) next = this.clamp(this.value - step); // 端に張り付かないよう反対側へ
          this.set(next);
          this.scheduleNext();
        }, wait);
      }
    }
  );
}
